/* Lemyn welcome offer. 16 Oct 2026 (Joe): email first, then an OPTIONAL phone step (20% + Lemyn VIP), then ONE code at the end.
   The email is saved on the first step (15% code made then), the code is only shown at the end: 20% with the phone, or 15% via "I'll stick with 15%". */
(function() {
  if (window.__lemynWelcome) return;
  window.__lemynWelcome = !0;
  var KEY = "lemyn.welcome.v2";

  function load() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || "null") || {}
    } catch (e) {
      return {}
    }
  }

  function save() {
    try {
      localStorage.setItem(KEY, JSON.stringify(W))
    } catch (e) {}
  }
  var W = load();
  W.bonus = "pct";
  var SU = "https://o3zbhndodykhofnap5wirbh4340rkhbc.lambda-url.us-east-1.on.aws/signup";

  function post(o) {
    return fetch(SU, {
      method: "POST",
      headers: {
        "content-type": "application/json"
      },
      body: JSON.stringify(o)
    }).then(function(r) {
      return r.json()
    }).catch(function() {
      return null
    })
  }

  function applyCode(c) {
    try {
      fetch("/discount/" + encodeURIComponent(c), {
        credentials: "same-origin"
      }).catch(function() {})
    } catch (e) {}
  }
  if (W.code && !W.real) {
    W = {
      bonus: "pct"
    };
    try {
      localStorage.setItem(KEY, JSON.stringify(W))
    } catch (e) {}
  }
  var BON = {
      gift: {
        label: "a free 2 oz travel sanitizer with your first order",
        done: "Your free 2 oz travel sanitizer ships with your first order.",
        chip: "&minus;15% + free travel size"
      },
      pct: {
        label: "20% off instead of 15%",
        done: "Your welcome discount is now 20%.",
        chip: "&minus;20%"
      }
    },
    ABC = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";

  function newCode() {
    for (var c = "", i = 0; i < 6; i++) c += ABC[Math.floor(Math.random() * ABC.length)];
    return "LEMYN-" + c
  }

  function code() {
    return W.code || "LEMYN-\xB7\xB7\xB7\xB7\xB7\xB7"
  }

  function until() {
    if (!W.exp) return "";
    var d = new Date(W.exp);
    return d.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric"
    })
  }

  function esc(s) {
    return String(s || "").replace(/[&<>"]/g, function(c) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;"
      } [c]
    })
  }
  var css = document.createElement("style");
  css.textContent = ['.lw{position:fixed;left:16px;bottom:16px;z-index:92;width:min(370px,calc(100vw - 32px));max-height:min(620px,calc(100vh - 110px));display:flex;flex-direction:column;background:var(--paper,#FBF5EC);color:var(--ink,#191713);border:1px solid var(--line,#E6DAC8);border-radius:22px;box-shadow:0 18px 50px rgba(20,15,10,.22);font-family:var(--body,"Source Sans 3",-apple-system,sans-serif);font-size:15.5px;line-height:1.45;transform:translateY(16px);opacity:0;transition:transform .35s cubic-bezier(.2,.8,.2,1),opacity .25s}', ".lw.on{transform:none;opacity:1}", "@media(max-width:560px){.lw{left:8px;right:8px;bottom:8px;width:auto;max-height:72vh}}", ".lw-h{display:flex;align-items:center;gap:10px;padding:14px 14px 10px 16px;border-bottom:1px solid var(--line,#E6DAC8)}", ".lw-dot{width:26px;height:26px;flex:none;border-radius:50%;background:radial-gradient(circle at 35% 30%,#FFB38F,#E8552F 60%,#B93A1A);box-shadow:0 0 0 3px rgba(232,85,47,.15)}", '.lw-h b{font-family:var(--disp,"Archivo",sans-serif);font-weight:900;font-size:15px;letter-spacing:-.01em}', ".lw-h small{display:block;font-size:12px;color:var(--mute,#6E6458);font-weight:400}", ".lw-x{margin-left:auto;width:32px;height:32px;border-radius:50%;border:0;background:transparent;color:var(--mute,#6E6458);font-size:20px;cursor:pointer}", ".lw-x:hover{background:var(--paper2,#F3E7D8)}", ".lw-b{padding:14px 16px 6px;overflow:auto;display:flex;flex-direction:column;gap:8px}", ".lw-m{max-width:88%;padding:10px 13px;border-radius:16px 16px 16px 4px;background:var(--card,#fff);border:1px solid var(--line,#E6DAC8);animation:lwIn .3s ease both}", ".lw-m.me{align-self:flex-end;border-radius:16px 16px 4px 16px;background:#191713;color:#FBF5EC;border-color:#191713}", ".lw-m b{font-weight:800}", "@keyframes lwIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}", ".lw-code{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-top:8px;padding:10px 12px;border-radius:12px;border:1.5px dashed #E8552F;background:#FFF4EE}", '.lw-code span{font:700 15px/1 var(--mono,"IBM Plex Mono",monospace);letter-spacing:.06em;color:#191713;white-space:nowrap}', ".lw-code em{text-align:right}", ".lw-code em{font-style:normal;font-size:12.5px;color:#B93A1A;font-weight:700}", ".lw-f{padding:10px 16px 16px}", ".lw-row{display:flex;gap:8px}", ".lw-in{flex:1;min-width:0;padding:13px 14px;border-radius:14px;border:1.5px solid var(--line,#E6DAC8);background:var(--card,#fff);color:inherit;font:inherit;font-size:16px}", ".lw-in:focus{outline:none;border-color:#E8552F;box-shadow:0 0 0 3px rgba(232,85,47,.15)}", ".lw-in.bad{border-color:#C0392B}", '.lw-go{padding:0 18px;border:0;border-radius:14px;background:#E8552F;color:#fff;font:800 15px/1 var(--disp,"Archivo",sans-serif);cursor:pointer;white-space:nowrap}', ".lw-go:hover{background:#D24722}", '.lw-big{display:block;width:100%;padding:14px;border-radius:999px;border:0;background:#E8552F;color:#fff;font:800 16px/1.2 var(--disp,"Archivo",sans-serif);cursor:pointer}', ".lw-big:hover{background:#D24722}", ".lw-skip{background:none;border:0;color:var(--mute,#6E6458);font:inherit;font-size:13.5px;text-decoration:underline;text-underline-offset:3px;cursor:pointer;padding:6px 0 0}", ".lw-fine{margin-top:8px;font-size:11.5px;line-height:1.45;color:var(--mute,#6E6458)}", ".lw-chk{display:flex;gap:8px;align-items:flex-start;margin-top:10px;font-size:11.5px;line-height:1.45;color:var(--mute,#6E6458);cursor:pointer}", ".lw-chk input{width:17px;height:17px;flex:none;margin-top:1px;accent-color:#E8552F}", ".lw-chk a{color:inherit}", ".lw-fine a{color:inherit}", ".lw-err{font-size:12.5px;color:#C0392B;margin-top:6px}", ".lw-err a{color:#C0392B;font-weight:700}", ".lw-hp{position:absolute!important;left:-9999px!important;width:1px;height:1px;opacity:0}", '.lw-tab{position:fixed;left:16px;bottom:16px;z-index:88;display:flex;align-items:center;gap:9px;padding:12px 18px 12px 12px;border-radius:999px;border:2px solid rgba(255,255,255,.9);background:#E8552F;color:#fff;font:900 16px/1 var(--disp,"Archivo",sans-serif);letter-spacing:-.01em;box-shadow:0 10px 30px rgba(232,85,47,.45),0 2px 8px rgba(0,0,0,.25);cursor:pointer;transition:transform .2s,background .2s}', ".lw-tab:hover{transform:translateY(-2px);background:#D24722}", ".lw-tab .lw-gift{width:22px;height:22px;flex:none}", ".lw-tab.nudge{animation:lwNudge 1s ease 1}", "@keyframes lwNudge{0%,100%{transform:none}20%{transform:translateY(-6px) rotate(-3deg)}40%{transform:translateY(0) rotate(2deg)}60%{transform:translateY(-3px) rotate(-1deg)}80%{transform:none}}", "@media(prefers-reduced-motion:reduce){.lw-tab.nudge{animation:none}}", "html body .lw-tab:not([style*=none]){display:flex!important}", "html body .lw{display:flex!important}", "@media(max-width:560px){.lw-tab{left:10px;bottom:12px;padding:10px 15px 10px 10px;font-size:15px}}", ".mockstrip .lw-ctl{display:inline-flex;gap:6px;align-items:center;margin-left:auto}", '.mockstrip .lw-ctl button{font:600 11px/1 "IBM Plex Mono",Menlo,monospace;padding:5px 8px;border-radius:999px;border:1px solid #3A362F;background:transparent;color:#EFE9DE;cursor:pointer}', ".mockstrip .lw-ctl button.on{background:#E4FF17;color:#191713;border-color:#E4FF17}"].join("\n"), document.head.appendChild(css);
  var card = null,
    tab = null,
    t0 = 0,
    HP = '<input class="lw-hp" type="text" name="company_site" tabindex="-1" autocomplete="off" aria-hidden="true">';

  function shell() {
    card && card.remove(), card = document.createElement("section"), card.className = "lw", card.setAttribute("aria-label", "15% off your first order"), card.innerHTML = '<div class="lw-h"><span class="lw-dot"></span><div><b>Lemyn Concierge</b><small>Freshly made in Florida</small></div><button class="lw-x" type="button" aria-label="Close">&times;</button></div><div class="lw-b"></div><div class="lw-f"></div>', document.body.appendChild(card), card.querySelector(".lw-x").onclick = close, requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        card.classList.add("on")
      })
    }), tab && (tab.style.display = "none")
  }

  function say(html, me) {
    var b = card.querySelector(".lw-b"),
      m = document.createElement("div");
    return m.className = "lw-m" + (me ? " me" : ""), m.innerHTML = html, b.appendChild(m), b.scrollTop = b.scrollHeight, m
  }

  function foot(html) {
    var f = card.querySelector(".lw-f");
    f.innerHTML = html, t0 = Date.now();
    var i = f.querySelector(".lw-in");
    return i && setTimeout(function() {
      try {
        i.focus({
          preventScroll: !0
        })
      } catch (e) {}
    }, 350), f
  }

  function botty(f) {
    var hp = f.querySelector(".lw-hp");
    return hp && hp.value || Date.now() - t0 < 900
  }

  function close() {
    if (card) {
      card.classList.remove("on");
      var c = card;
      setTimeout(function() {
        c.remove()
      }, 300), card = null
    }
    paintTab()
  }

  function paintTab() {
    if (W.email) {
      tab && (tab.remove(), tab = null);
      return
    }
    tab || (tab = document.createElement("button"), tab.type = "button", tab.className = "lw-tab", tab.innerHTML = '<svg class="lw-gift" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C10 3 12 8 12 8s2-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>Get 15% off', setTimeout(function() {
      tab && tab.classList.add("nudge")
    }, 4e3), tab.setAttribute("aria-label", "Get 15% off your first order"), tab.onclick = open, document.body.appendChild(tab)), tab.style.display = card ? "none" : ""
  }

  function open() {
    if (shell(), W.email) {
      say("You are on the list" + (W.name ? ", " + esc(W.name) : "") + ". Your code <b>" + code() + "</b> (" + (W.pct || 15) + "% off) is saved for your first order, until " + until() + ".");
      var f0 = foot('<button class="lw-big" type="button">Keep shopping</button>');
      f0.querySelector("button").onclick = close;
      return
    }
    say("<b>Join our newsletter and get 15% off your first order.</b> New blends, Steffi&rsquo;s tips and members-only offers &mdash; a few emails a month.");
    var f = foot('<form novalidate><div class="lw-row">' + HP + '<input class="lw-in" name="e" type="email" inputmode="email" autocomplete="email" placeholder="Your email" aria-label="Email"><button class="lw-go">Get 15% off</button></div><div class="lw-err" role="alert"></div><div class="lw-fine">By signing up, you agree to receive marketing emails from Lemyn Organics. We never share your email. Unsubscribe anytime. <a href="privacy.html" target="_blank">Privacy Policy</a></div></form>'),
      form = f.querySelector("form"),
      inp = f.querySelector("[name=e]"),
      err = f.querySelector(".lw-err");
    form.onsubmit = function(e) {
      e.preventDefault();
      var v = inp.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(v)) {
        inp.classList.add("bad"), err.textContent = "That email does not look quite right.";
        return
      }
      var fix = typo(v);
      if (fix && !form._ok) {
        err.innerHTML = 'Did you mean <a href="#" class="lw-fix">' + esc(fix) + '</a>? <a href="#" class="lw-keep">No, keep it</a>', err.querySelector(".lw-fix").onclick = function(ev) {
          ev.preventDefault(), inp.value = fix, err.textContent = "", inp.classList.remove("bad")
        }, err.querySelector(".lw-keep").onclick = function(ev) {
          ev.preventDefault(), form._ok = !0, err.textContent = ""
        };
        return
      }
      if (botty(f)) {
        say("Thanks!");
        return
      }
      var em = v.toLowerCase();
      say(esc(em), !0);
      var w8 = say("One moment&hellip;");
      form.querySelector("button").disabled = !0;
      post({
        email: em
      }).then(function(r) {
        w8.remove();
        form.querySelector("button").disabled = !1;
        if (!r || !r.ok) {
          if (r && r.returning) {
            W.email = em, save(), say(esc(r.message));
            var g = foot('<button class="lw-big" type="button">Keep shopping</button>');
            g.querySelector("button").onclick = close;
            return
          }
          say(esc(r && r.message || "Something went wrong. Please try again in a moment."));
          return
        }
        W.email = em, W.at = new Date().toISOString(), W.code = r.code, W.pct = r.pct, W.real = !0, W.exp = Date.now() + 14 * 864e5, save(), applyCode(r.code), r.pct >= 20 ? (showCode(), askName()) : askPhone()
      })
    }
  }
  var DOM = ["gmail.com", "yahoo.com", "hotmail.com", "outlook.com", "icloud.com", "aol.com", "comcast.net", "live.com", "msn.com", "me.com"];

  function lev(a, b) {
    var m = [],
      i, j;
    for (i = 0; i <= b.length; i++) m[i] = [i];
    for (j = 0; j <= a.length; j++) m[0][j] = j;
    for (i = 1; i <= b.length; i++)
      for (j = 1; j <= a.length; j++) m[i][j] = b[i - 1] === a[j - 1] ? m[i - 1][j - 1] : Math.min(m[i - 1][j - 1] + 1, m[i][j - 1] + 1, m[i - 1][j] + 1);
    return m[b.length][a.length]
  }

  function typo(v) {
    var p = v.toLowerCase().split("@");
    if (p.length !== 2) return null;
    var d = p[1].replace(/\.con$|\.cmo$|\.cm$|\.co$/, ".com");
    if (DOM.indexOf(d) >= 0) return d === p[1] ? null : p[0] + "@" + d;
    var best = null,
      bd = 3;
    return DOM.forEach(function(x) {
      var k = lev(d, x);
      k < bd && (bd = k, best = x)
    }), best && bd <= 2 ? p[0] + "@" + best : null
  }

  function showCode() {
    say("You are in &mdash; welcome to Lemyn! Here is <b>your own code: " + W.pct + "% off</b>, already saved in your cart. It is yours alone, good for your first order until " + until() + '. We have emailed it to you too.<div class="lw-code"><span>' + code() + "</span><em>&minus;" + W.pct + "% &middot; until " + until() + "</em></div>");
    W.email && post({ email: W.email, mailCode: !0 }) /* 16 Oct 2026: the final code also goes by email, once */
  }

  function askPhone() {
    say("You are on the list. <b>Want 20% instead of 15%?</b> Add your mobile and you get <b>20% off your first order</b>, plus <b>Lemyn VIP</b>: first to hear about new blends and restocks, and specials our email list never sees.");
    var f = foot('<form novalidate><div class="lw-row">' + HP + '<input class="lw-in" name="p" type="tel" inputmode="tel" autocomplete="tel" placeholder="Mobile number" aria-label="Mobile number"><button class="lw-go">Get 20%</button></div><div class="lw-err" role="alert"></div><label class="lw-chk"><input type="checkbox" name="c"> <span>Yes, text me Lemyn VIP offers and news at this number. Up to 4 msgs/month. Msg &amp; data rates may apply. Reply STOP to opt out, HELP for help. Consent is not a condition of purchase. <a href="sms-terms.html" target="_blank">Terms</a> &middot; <a href="privacy.html" target="_blank">Privacy Policy</a></span></label><button class="lw-skip" type="button">I&rsquo;ll stick with 15%</button></form>'),
      form = f.querySelector("form"),
      inp = f.querySelector("[name=p]"),
      err = f.querySelector(".lw-err");
    f.querySelector(".lw-skip").onclick = function() {
      say("I&rsquo;ll stick with 15%", !0), showCode(), askName()
    }, form.onsubmit = function(e) {
      e.preventDefault();
      var d = inp.value.replace(/\D/g, "");
      if (d.length === 11 && d[0] === "1" && (d = d.slice(1)), d.length !== 10) {
        inp.classList.add("bad"), err.textContent = "Please enter a 10-digit US mobile number.";
        return
      }
      if (!form.querySelector("[name=c]").checked) {
        err.textContent = "Please tick the box to get Lemyn VIP texts, or choose \u201cI\u2019ll stick with 15%\u201d.";
        return
      }
      if (botty(f)) return;
      say("(" + d.slice(0, 3) + ") " + d.slice(3, 6) + "-" + d.slice(6), !0);
      var w8 = say("One moment&hellip;");
      post({
        email: W.email,
        phone: d,
        consent: !0,
        consentText: (form.querySelector(".lw-chk span") || {}).textContent || "",
        page: location.pathname
      }).then(function(r) {
        w8.remove();
        if (!r || !r.ok) {
          say(esc(r && r.message || "Something went wrong. Please try again in a moment."));
          return
        }
        W.phone = d, W.pct = r.pct, W.code = r.code, W.vip = !0, save(), applyCode(r.code), say("Welcome to Lemyn VIP."), showCode(), askName()
      })
    }
  }

  function askName() {
    say("Last thing, and only if you like: what should we call you?");
    var f = foot('<form class="lw-row" novalidate>' + HP + '<input class="lw-in" name="n" autocomplete="given-name" placeholder="First name" aria-label="First name"><button class="lw-go">Done</button></form><button class="lw-skip" type="button">Skip</button>');

    function fin() {
      say("All set" + (W.name ? ", " + esc(W.name) : "") + ". Happy shopping!");
      var g = foot('<button class="lw-big" type="button">Keep shopping</button>');
      g.querySelector("button").onclick = close
    }
    f.querySelector("form").onsubmit = function(e) {
      e.preventDefault();
      var v = f.querySelector("[name=n]").value.trim();
      v && (W.name = v.slice(0, 40), save(), say(esc(W.name), !0)), fin()
    }, f.querySelector(".lw-skip").onclick = fin
  }

  function ctl() {
    var strip = document.querySelector(".mockstrip");
    if (!strip) return;
    var w = document.createElement("span");
    if (w.className = "lw-ctl", w.innerHTML = '<span style="color:#9C948A">15% offer:</span><button type="button" data-a="reset">reset (new visitor)</button><button type="button" data-a="gift">phone bonus: travel size</button><button type="button" data-a="pct">phone bonus: 20%</button>', strip.appendChild(w), !document.getElementById("prReset")) {
      var pw = document.createElement("span");
      pw.className = "lw-ctl", pw.style.marginLeft = "8px", pw.innerHTML = '<span style="color:#9C948A">Pro:</span><button type="button" data-p="reset">reset</button>', strip.appendChild(pw), pw.querySelector("button").onclick = function() {
        try {
          localStorage.removeItem("lemyn.pro.v1")
        } catch (e) {}
        location.reload()
      }
    }

    function paint() {
      w.querySelector("[data-a=gift]").classList.toggle("on", W.bonus === "gift"), w.querySelector("[data-a=pct]").classList.toggle("on", W.bonus === "pct")
    }
    w.onclick = function(e) {
      var a = e.target.getAttribute && e.target.getAttribute("data-a");
      if (a) {
        if (a === "reset") {
          var b = W.bonus;
          W = {
            bonus: b
          }, save(), close(), paintTab()
        }(a === "gift" || a === "pct") && (W.bonus = a, save(), paint())
      }
    }, paint()
  }
  window.LemynWelcome = {
    state: function() {
      return W
    },
    code: code,
    open: open
  }, ctl(), paintTab()
})();